import React, { createContext, useContext } from "react";

export interface ThemeContext {
  fontFamilyBody: string;
  fontFamilyHeading: string;
}

export const ThemeContext = createContext<ThemeContext>({
  fontFamilyBody: ``,
  fontFamilyHeading: ``,
});

export function useTheme() {
  return useContext(ThemeContext);
}

interface ThemeProviderProps {
  children: React.ReactNode;
  theme: ThemeContext;
}

export function ThemeProvider(props: ThemeProviderProps) {
  const { children, theme } = props;

  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
}
